import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../view/Login'
import Register from '../view/Register'
import Home from '../view/Home'
import EnterpriseNumber from '../view/Enterprise_number'

// 安装路由
Vue.use(VueRouter);

// 配置导出路由
const router = new VueRouter({
  routes: [{
    path: "/",
    redirect: "/Enterprise_number"
  },
  {
    name: "Enterprise",
    path: '/Enterprise_number',
    component: EnterpriseNumber
  },
  {
    name: "Login",
    path: '/login',
    component: Login
  },
  {
    name: "Register",
    path: '/register',
    component: Register
  },
  {
    name: "Home",
    path: '/home',
    component: Home,
    children: [
      {
        name: "Chat",
        path: "/home/chat",
        component: () => import("../view/Chat"),
      },
      {
        name: "Friend",
        path: "/home/friend",
        component: () => import("../view/Friend"),
      },
      {
        name: "GROUP",
        path: "/home/group",
        component: () => import("../view/Group"),
      }
    ]
  }
  ]
});
router.beforeEach((to, from, next) => {
  const tenantId = localStorage.getItem('tenantId')
  // 如果目标就是企业号页，或者 tenantId 已经有值，就放行
  if (to.path === '/Enterprise_number' || (tenantId && tenantId.trim() !== '')) {
    return next()
  }
  // 否则跳到企业号页
  return next({ path: '/Enterprise_number' }) 
})

export default router;